module.exports = "<p>\r\n  group-report works!\r\n</p>\r\n"